import { render, staticRenderFns } from "./TaxReturnResico.vue?vue&type=template&id=72a1242c&scoped=true"
import script from "./TaxReturnResico.vue?vue&type=script&lang=js"
export * from "./TaxReturnResico.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnResico.vue?vue&type=style&index=0&id=72a1242c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1242c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a1242c')) {
      api.createRecord('72a1242c', component.options)
    } else {
      api.reload('72a1242c', component.options)
    }
    module.hot.accept("./TaxReturnResico.vue?vue&type=template&id=72a1242c&scoped=true", function () {
      api.rerender('72a1242c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnResico.vue"
export default component.exports